import { api } from 'API/axios';
import { addImposterToUrl } from 'Utils';

const baseURL = '/Recommendations';

interface IRecommendationItem {
  reqNumber: number;
  shemeshCatalogNumber: number;
  nextEntitleDate: Date;
  medicationName?: string;
  nextRefreshDate?: Date;
  medicationCode: number;
}

export interface IRecommendations {
  id?: number;
  identifier: number;
  caseNumber: string;
  createDate: Date;
  isClosed: boolean;
  title: string;
  description: string;
  subjectId: number;
  entityJSON: {
    items: IRecommendationItem[];
    title?: string;
  };
}

export interface IMedicationRecommendation extends IRecommendationItem {
  medicationName: string;
  nextRefreshDate: Date;
  medicationCode: number;
}

export const getRecommendations = async () => {
  const recommendations = await api.get<IRecommendations[]>(
    addImposterToUrl(baseURL, true)
  );
  if (recommendations.data) return recommendations.data;
};

export const deleteRecommendation = async (body: any, reqPath: string) => {
  const deleteRequest = await api.post(
    addImposterToUrl(`${baseURL}/${reqPath}`, true),
    body,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  if (deleteRequest.data) return deleteRequest.data;
};
